import { useEffect } from "react";
import { normalizeHostTheme, hostThemeMeta } from "../lib/hostThemes";

const DOC_THEME_ATTR = "data-host-theme";
const DOC_DARK_ATTR = "data-host-theme-dark";

/**
 * Applies a host's public-page theme via data-host-theme (CSS vars).
 * Use only with the PAGE OWNER theme from the API — never the viewer's.
 *
 * When syncDocument is true (full-page public links), mirrors the theme onto
 * <html> so chrome outside this shell (e.g. SiteFooter) inherits canvas/ink.
 * Keep false for listing drawers so the background route stays on its own theme.
 */
export default function HostThemedShell({
  theme,
  className = "",
  syncDocument = true,
  children,
  ...rest
}) {
  const themeId = normalizeHostTheme(theme);
  const meta = hostThemeMeta(themeId);

  useEffect(() => {
    if (!syncDocument) return undefined;

    const root = document.documentElement;
    root.setAttribute(DOC_THEME_ATTR, themeId);
    if (meta.dark) root.setAttribute(DOC_DARK_ATTR, "true");
    else root.removeAttribute(DOC_DARK_ATTR);

    return () => {
      if (root.getAttribute(DOC_THEME_ATTR) === themeId) {
        root.removeAttribute(DOC_THEME_ATTR);
        root.removeAttribute(DOC_DARK_ATTR);
      }
    };
  }, [themeId, meta.dark, syncDocument]);

  return (
    <div
      data-host-theme={themeId}
      data-host-theme-dark={meta.dark ? "true" : undefined}
      className={className}
      {...rest}
    >
      {children}
    </div>
  );
}
